var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tree-transfer',{attrs:{"title":_vm.title,"from_data":_vm.allMenuList,"to_data":_vm.roleMenuList,"defaultProps":{ label: 'title', children: 'subs' },"pid":"parentId","height":"250px","filter":"","openAll":""},on:{"add-btn":_vm.handleChange,"remove-btn":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }